module.exports = __webpack_public_path__ + "static/img/y31.bd1ab0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y31.jpg
// module id = gjnl
// module chunks = 1